import React from 'react';
import './App.css';
import Toolbar from './Toolbar';
import { Editor, EditorState, RichUtils, getDefaultKeyBinding, KeyBindingUtil } from 'draft-js';

function keyBindingFunction(event) {
  if (KeyBindingUtil.hasCommandModifier(event) && event.shiftKey && event.key === 'x') {
    return 'strikethrough';
  }

  if (KeyBindingUtil.hasCommandModifier(event) && event.shiftKey && event.key === '7') {
    return 'ordered-list';
  }

  if (KeyBindingUtil.hasCommandModifier(event) && event.shiftKey && event.key === '8') {
    return 'unordered-list';
  }

  if (KeyBindingUtil.hasCommandModifier(event) && event.shiftKey && event.key === '9') {
    return 'blockquote';
  }

  if (KeyBindingUtil.hasCommandModifier(event) && event.shiftKey && event.key === 'h') {
    return 'highlight';
  }

  return getDefaultKeyBinding(event);
}

const styleMap = {
  'HIGHLIGHT': {
    'backgroundColor': '#faed27',
  }
};

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createEmpty()
    };

    this.onChange = this.onChange.bind(this);
    this.handleKeyCommand = this.handleKeyCommand.bind(this);
    this.toggleInlineStyle = this.toggleInlineStyle.bind(this);
    this.toggleBlockType = this.toggleBlockType.bind(this);
  }

  onChange (editorState) {
    this.setState({editorState});
  }

  handleKeyCommand(command) {
    // inline formatting key commands handles bold, italic, code, underline
    var editorState = RichUtils.handleKeyCommand(this.state.editorState, command);

    if (!editorState && command === 'strikethrough') {
      editorState = RichUtils.toggleInlineStyle(this.state.editorState, 'STRIKETHROUGH');
    }

    if (!editorState && command === 'highlight') {
      editorState = RichUtils.toggleInlineStyle(this.state.editorState, 'HIGHLIGHT');
    }

    if (!editorState && command === 'blockquote') {
      editorState = RichUtils.toggleBlockType(this.state.editorState, 'blockquote');
    }

    if (!editorState && command === 'ordered-list') {
      editorState = RichUtils.toggleBlockType(this.state.editorState, 'ordered-list-item');
    }

    if (!editorState && command === 'unordered-list') {
      editorState = RichUtils.toggleBlockType(this.state.editorState, 'unordered-list-item');
    }

    if (editorState) {
      this.setState({editorState});
      return 'handled';
    }

    return 'not-handled';
  }

  toggleInlineStyle (style) {
    this.setState({
      editorState: RichUtils.toggleInlineStyle(this.state.editorState, style)
    });
  }

  toggleBlockType (block) {
    this.setState({
      editorState: RichUtils.toggleBlockType(this.state.editorState, block)
    });
  }

  render() {
    const contentState = this.state.editorState.getCurrentContent();
    let showPlaceholder = false;

    if (!contentState.hasText()) {
      if (contentState.getBlockMap().first().getType() === 'unstyled') {
        showPlaceholder = true;
      }
    }

    const placeholderClass = showPlaceholder ? 'show-placeholder' : 'hide-placeholder';

    return (
      <div className={`my-little-app ${placeholderClass}`}>
        <h1>Playing with Draft!</h1>
        <Toolbar
          editorState={this.state.editorState}
          toggleBlockType={this.toggleBlockType}
          toggleInlineStyle={this.toggleInlineStyle}
        />
        <div className="draft-editor-wrapper">
          <Editor
            customStyleMap={styleMap}
            placeholder={"Start typing!"}
            editorState={this.state.editorState}
            onChange={this.onChange}
            handleKeyCommand={this.handleKeyCommand}
            keyBindingFn={keyBindingFunction}
          />
        </div>
      </div>
    );
  }
}

export default App;
